import CONFIG from '../config/config';
import getLanguage from '../helpers/language';

interface initParams {
  appId: string;
  publicKey: string;
}

const initialize = async ({appId, publicKey}: initParams)=> {
  const cachedData = window.sessionStorage && window.sessionStorage.getItem(`dcinnovationChatBot_${appId}`);
  if (cachedData) return JSON.parse(cachedData).configuration;

  const headers = new Headers();
  headers.append('Accept', 'application/json');
  headers.append('Ocp-Apim-Subscription-Key', publicKey);

  const requestOptions: RequestInit = {
    method: 'GET',
    headers: headers,
  };

  try {
    const response = await fetch(CONFIG.domain_url + 'client/get_client_custom_initialization/' + appId + '/?language=' + getLanguage(), requestOptions);
    const data = await response.json();

    if (window.sessionStorage) {
      window.sessionStorage.setItem(`dcinnovationChatBot_${appId}`, JSON.stringify({ configuration: data }));
    }
    return data;
  } catch {
    return null;
  }
};

export default initialize;